require('./myProfileExtractsList.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
import Immutable from 'immutable';
import moment from 'moment';
import {sortByOrder} from 'lodash/collection';

// @ commons
const classNames = require('classnames');
const { FormattedText, formatText } = require('core/i18n').i18n;
const { OKLink } = require('commonsComponents/OKLink');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');

// @ components
const DocumentsTable = require('components/myProfile/documentsTable/documentsTable');
const ExtractsFilterTag = require('components/myProfile/extractsFilter/extractsFilterTag');
const { LoadingSection } = require('commonsComponents/loadingSection');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const { okInsuranceComponents: { myProfileDocumentationInsurancesView: MyProfileDocumentationInsurancesView } } = require('ok-insurance');

// @ constants
const  { DOCUMENTS_GROUPS } = require('constants/documentsGroups');
import { DATE_FORMAT_API } from 'constants/index';

class MyProfileExtractsList extends React.Component {
    componentWillReceiveProps(newProps) {
        if (this.props.groupSelected !== newProps.groupSelected) {
            newProps.mifid2DocumentSendEmailReset && newProps.mifid2DocumentSendEmailReset();
        }
    }

    buildMifid2SendMailError() {
        const { mifid2DocumentByEmailError } = this.props;
        if (__CONTACT_CENTER__ || !mifid2DocumentByEmailError) return null;

        return (
            <div className="extracts-list__send-mail-error-section">
                <FormattedText className="extracts-list__send-mail-error-message" value="profileDocumentation-sendMailError" />
            </div>
        );
    }

    buildDocumentList() {
        const {
            callbackDownloadFile,
            callbackDownloadFiscalFile,
            documentsByGroup,
            filters,
            groupSelected,
            additionalDocuments,
            immAccounts,
            isPartialFetching,
            onClearFilter,
            onResetFilter,
            callbackDownloadMifid2File,
            callbackSendMifid2DocumentByEmail,
            setSelectedDocument,
            downloadById
        } = this.props;

        const handleViewAllButtonClick = () => this.handleViewAllButtonClick();

        const viewMoreButton = classNames('extracts-list__view-more-button-row', {
            'extracts-list__view-more-button-row--invisible': !(documentsByGroup.getIn([groupSelected, 'hasMore']) === 'S')
        });

        const getValueByProperty = (additionalDocuments, prop) => {
            return additionalDocuments.get('fields').filter(field => field.get('name') === prop).first().get('value');
        }

        const additionalDocumentationMapperToDocumentation = document => {
          if (document.get('internalIdx')) {
            return {
              currentDocument: false,
              fechaAlta: moment(getValueByProperty(document, 'FECHADOCUM')).format(DATE_FORMAT_API),
              nombreTipoComunicacion: getValueByProperty(document, 'DENOMINACION'),
              isFetching: document.get('isFetching'),
              isFiscalFileType: true,
              file: {
                process: document.get('process'),
                internalIdx: document.get('internalIdx'),
                segmentId: document.get('segmentId'),
                pageTo: document.get('pageTo') || 0,
                queryId: document.get('queryId'),
              },
            };
          } 
            return document;
          
        };

        const getDocuments = () => {
            const isAllGroupsSelected = groupSelected === '0000';
            const isAllTaxInformationSelected = groupSelected === '0033';
            if(isAllGroupsSelected || isAllTaxInformationSelected) {
                    const data = !additionalDocuments ? Immutable.List([]) : additionalDocuments.get('additionalDocumentation').map(document =>  additionalDocumentationMapperToDocumentation(document));
                    const mergedData = data.size > 0 ?
                    [...documentsByGroup.getIn([groupSelected, 'documents']).toJS(), ...data.toJS()] : documentsByGroup.getIn([groupSelected, 'documents']).toJS();

                    const sortedData =  sortByOrder(mergedData, ['fechaAlta'], ['desc']);
                return Immutable.fromJS(sortedData);
            }

            return documentsByGroup.getIn([groupSelected, 'documents'])
        }

        const mifid2SendMailError = this.buildMifid2SendMailError();

        return (
            <div className="extracts-list__content">
                <ExtractsFilterTag
                    immFilter={filters}
                    onClearFilter={onClearFilter}
                    resetFilter={onResetFilter}
                />
                <DocumentsTable
                    data={getDocuments()}
                    immAccounts={immAccounts}
                    maxDocumentsToSee={this.props.maxDocumentsToSee}
                    showDocumentationType={true}
                    showAlias={true}
                    showCurrentDocument={false}
                    showAutoDates={this.props.showAutoDates}
                    callbackDownloadFile={callbackDownloadFile}
                    callbackDownloadFiscalFile={callbackDownloadFiscalFile}
                    callbackDownloadMifid2File={callbackDownloadMifid2File}
                    callbackSendMifid2DocumentByEmail={callbackSendMifid2DocumentByEmail}
                    groupSelected={groupSelected}
                    setSelectedDocument={setSelectedDocument}
                    downloadById={downloadById}
                />
                {
                    isPartialFetching ?
                        <LoadingSection /> :
                        (<div className={viewMoreButton}>
                            <div className="extracts-list__view-more-button">
                                <OKLink
                                    onClick={handleViewAllButtonClick}
                                    modifier="editorial"
                                >
                                    <FormattedText value="profileExtracts-extractsViewMoreButton" format="uppercase" />
                                </OKLink>
                            </div>
                        </div>
                )}

                <ContactCenterRender>
                    {mifid2SendMailError}
                </ContactCenterRender>

            </div>
        );
    }

    buildEmptyState() {
        const { filters, onResetFilter, onClearFilter } = this.props;

        return (
            <div className="extracts-list__content">
                <ExtractsFilterTag
                    immFilter={filters}
                    onClearFilter={onClearFilter}
                    resetFilter={onResetFilter}
                />
                <EmptyState primaryText={formatText('profileExtracts-extractsEmptyDocuments')} iconType="search-banking" />
            </div>
        );
    }

    handleViewAllButtonClick() {
        this.props.requestMoreDocuments(true);
    }

    render() {
        const {
            documentsByGroup,
            groupSelected,
            isPartialFetching,
            documents,
            additionalDocuments,
            immInsurances,
            callbackDownloadFileInsurances,
            documentDownloadingPolicyNumber,
            documentsFetch,
            isFetchingContactCenterDocuments,
        } = this.props;
        const group = DOCUMENTS_GROUPS.filter(group => group.codGrupo === groupSelected)[0];
        let groupTitle;
        let content;
        let documentsGroupSelected = documentsByGroup.get(groupSelected);
        let isFetching = documents.get('isFetching');

        const insurancesIsEmpty = immInsurances ? !immInsurances.get('insurances').size : false;
        const insurancesIsFetching = immInsurances ? immInsurances.get('isFetching') : false;
        const insurancesIsFulfilled = immInsurances ? immInsurances.get('fulfilled') : true;
        const aditionalDocumentationIsFetching = additionalDocuments ? additionalDocuments.get('isFetching') : false;
        const aditionalDocumentationIsEmpty = additionalDocuments ? (additionalDocuments.get('additionalDocumentation').size > 0) : false;
        const isInsurancesSelected = groupSelected === '0022';
        const insurancesDocumentsView = (
            <MyProfileDocumentationInsurancesView
                immInsurances={immInsurances}
                callbackDownloadFileInsurances={callbackDownloadFileInsurances}
                documentDownloadingPolicyNumber={documentDownloadingPolicyNumber}
                documentsFetch={documentsFetch}
            />
        );
        let buildContent = () => {
            if (!documentsGroupSelected ||
                (!documentsGroupSelected.get('documents').size && isPartialFetching) ||
                isFetching ||
                (insurancesIsEmpty && insurancesIsFetching) ||
                (!insurancesIsEmpty && !insurancesIsFulfilled) ||
                isFetchingContactCenterDocuments  ||
                (aditionalDocumentationIsEmpty  && aditionalDocumentationIsFetching))
                {
                return <LoadingSection />;
            } else if ((!isInsurancesSelected && documentsGroupSelected && documentsGroupSelected.get('documents').size) || (!insurancesIsEmpty && isInsurancesSelected)) {
                const documentList = isInsurancesSelected ? insurancesDocumentsView : this.buildDocumentList();
                return documentList;
            } else {
                return this.buildEmptyState();
            }
        }

        if (group) {
            groupTitle = formatText(`groupNames-${group.codGrupo}`);
            content = buildContent();
        }

        return (
            <OKSectionBox title={groupTitle}>
                {content}
            </OKSectionBox>
        )
    }
}

MyProfileExtractsList.propTypes = {
    documents: PropTypes.object,
    documentsByGroup: PropTypes.object,
    additionalDocuments: PropTypes.object,
    immAccounts: PropTypes.object,
    isFetchingContactCenterDocuments: PropTypes.bool,
    filters: PropTypes.object.isRequired,
    groupSelected: PropTypes.string,
    isPartialFetching: PropTypes.bool,
    callbackDownloadFile: PropTypes.func.isRequired,
    callbackDownloadFiscalFile: PropTypes.func.isRequired,
    callbackDownloadMifid2File: PropTypes.func.isRequired,
    maxDocumentsToSee: PropTypes.number,
    onClearFilter: PropTypes.func.isRequired,
    onResetFilter: PropTypes.func.isRequired,
    downloadById: PropTypes.func,
    callbackSendMifid2DocumentByEmail: PropTypes.func,
    mifid2DocumentByEmailError: PropTypes.bool,
    mifid2DocumentSendEmailReset: PropTypes.func,
    requestMoreDocuments: PropTypes.func,
    showAutoDates: PropTypes.bool,
    immInsurances: PropTypes.object.isRequired,
    callbackDownloadFileInsurances: PropTypes.func,
    clearInsurancesOverallView: PropTypes.func,
    documentDownloadingPolicyNumber: PropTypes.string,
    documentsFetch: PropTypes.object,
    setSelectedDocument: PropTypes.func.isRequired,
};

MyProfileExtractsList.defaultProps = {
    showAutoDates: false,
    mifid2DocumentByEmailError: false,
    isFetchingContactCenterDocuments: false
}

module.exports = MyProfileExtractsList;
